import { api } from "./common/base";

export class AccessPolicyService {
  approve({ id }) {
    return api.post(`/access-policy/${id}/approve`).then((res) => res.data);
  }
  reject({ id }) {
    return api.post(`/access-policy/${id}/reject`).then((res) => res.data);
  }
  revoke({id}) {
    return api.post(`/access-policy/${id}/revoke`).then((res) => res.data);
  }
}
